var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreeningGreyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_80297",
    "data-name": "Group 80297",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19627",
    "data-name": "Rectangle 19627",
    width: 16,
    height: 20,
    fill: "#b1bae4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_79730",
    "data-name": "Group 79730",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110232",
    "data-name": "Path 110232",
    d: "M15.2,2.63a2.717,2.717,0,0,0-1.95-.83H12.5A1.882,1.882,0,0,0,10.62,0H5.37A1.873,1.873,0,0,0,3.5,1.8H2.75A2.7,2.7,0,0,0,.8,2.63,2.734,2.734,0,0,0,0,4.6V17.2a2.767,2.767,0,0,0,.8,1.97A2.7,2.7,0,0,0,2.75,20h10.5a2.818,2.818,0,0,0,1.95-.83A2.854,2.854,0,0,0,16,17.2V4.6a2.818,2.818,0,0,0-.8-1.97M5.5,2h5V3.6h-5ZM14,17.2a.856.856,0,0,1-.23.57.714.714,0,0,1-.52.23H2.75a.719.719,0,0,1-.53-.23A.8.8,0,0,1,2,17.2V4.6a.834.834,0,0,1,.23-.58.709.709,0,0,1,.52-.22H3.5A1.887,1.887,0,0,0,5.37,5.6h5.25A1.9,1.9,0,0,0,12.5,3.8h.75a.744.744,0,0,1,.52.22A.881.881,0,0,1,14,4.6Z",
    fill: "#b1bae4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19626",
    "data-name": "Rectangle 19626",
    width: 5,
    height: 1.6,
    transform: "translate(5.5 2)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110233",
    "data-name": "Path 110233",
    d: "M14,4.6V17.2a.856.856,0,0,1-.23.57.714.714,0,0,1-.52.23H2.75a.719.719,0,0,1-.53-.23A.8.8,0,0,1,2,17.2V4.6a.834.834,0,0,1,.23-.58.709.709,0,0,1,.52-.22H3.5A1.887,1.887,0,0,0,5.37,5.6h5.25A1.9,1.9,0,0,0,12.5,3.8h.75a.744.744,0,0,1,.52.22A.881.881,0,0,1,14,4.6",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110234",
    "data-name": "Path 110234",
    d: "M5.406,9.622h6a.625.625,0,0,0,0-1.25h-6a.625.625,0,0,0,0,1.25",
    fill: "#b1bae4",
    stroke: "#b1bae4",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110235",
    "data-name": "Path 110235",
    d: "M5.406,14.622h2a.625.625,0,0,0,0-1.25h-2a.625.625,0,0,0,0,1.25",
    fill: "#b1bae4",
    stroke: "#b1bae4",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreeningGreyIcon);
export default __webpack_public_path__ + "static/media/screening-grey-icon.8c96bddc1cd05da719be56e4c78b5ddc.svg";
export { ForwardRef as ReactComponent };